import Button, { ButtonProps } from "../Button";
import Loader from "../Loader";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

type LoadingButtonProps = {
  loading?: boolean;
  success?: boolean;
} & ButtonProps;

export default function LoadingButton({
  success,
  loading,
  children,
  ...props
}: React.PropsWithChildren<LoadingButtonProps>) {
  return (
    <div style={{ position: "relative" }}>
      <Button {...props}>{children}</Button>
      {success ? (
        <div
          style={{
            position: "absolute",
            top: 2,
            right: 2,
            color: "rgb(40, 180, 147)",
          }}
        >
          <IoMdCheckmarkCircleOutline size={40} />
        </div>
      ) : (
        loading && (
          <div style={{ position: "absolute", top: 6, right: 6 }}>
            <Loader size={32} thickness={4} color="#f33f3a" />
          </div>
        )
      )}
    </div>
  );
}
